import VisitList from "../visits/VisitList";

const OPDVisits = () => {
  return <VisitList type="opd" />;
};

export default OPDVisits;
